<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>合作往来核销</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.rid">
                <el-input v-model="queryParams.rid" placeholder="请输入RID" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.partner_current_rid">
                <el-input
                    v-model="queryParams.partner_current_rid"
                    placeholder="请输入合作往来RID"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
            <div class="main_header_item" v-if="postList.remark">
                <el-input v-model="queryParams.remark" placeholder="请输入备注" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="insert" icon="el-icon-plus" v-if="postList.addBtn">新增</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(2)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <crm-upload obj="partner_current_deduction" v-if="postList.uploadBtn" :display_update="false"></crm-upload>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="partner_current_deduction"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div
                                v-if="
                                    in_array(item.prop, [
                                        'partner_rid',
                                        'partner_current_rid',
                                        'budget_execution_report_rid',
                                        'budget_item_rid',
                                        'deal_detail_rid'
                                    ])
                                "
                            >
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>

                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page.sync="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array } from '../../../../../js/common';
import draggableList from '../../../../common/Drawer.vue';
import crmUpload from '../../../../common/Upload.vue';
export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload
    },
    name: 'partnerCurrentDeductionComponent',
    data() {
        return {
            draggable: {
                data_name: 'partner_current_deduction'
            },
            down_loading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('pageAndSerachSelect');
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                this.queryParams.partner_current_rid = this.postList.params.partner_current_rid || '';
                this.queryParams.partner_rid = this.postList.params.partner_rid || '';
                this.getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0,
                rid: '',
                partner_current_rid: '',
                partner_rid: '',
                remark: ''
            };
            this.saveQueryParams();
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('partner_current_deduction_params', JSON.stringify(this.queryParams));
            }
        },
        toDetail(row, prop) {
            if (prop == 'partner_rid' && row.partner_rid != '') {
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: row.partner_rid
                    }
                });
            } else if (prop == 'partner_current_rid' && row.partner_current_rid != '') {
                this.$router.push({
                    path: '/partnerCurrentDetail',
                    query: {
                        id: row.partner_current_rid
                    }
                });
            } else if (prop == 'budget_execution_report_rid' && row.budget_execution_report_rid != '') {
                this.$router.push({
                    path: '/budgetReportDetails',
                    query: {
                        id: row.budget_execution_report_rid,
                        mk_report_id: row.mk_report_id
                    }
                });
            } else if (prop == 'budget_item_rid' && row.budget_item_rid != '') {
                this.$router.push({
                    path: '/budgetItemDetails',
                    query: {
                        id: row.budget_item_rid
                    }
                });
            } else if (prop == 'deal_detail_rid' && row.deal_detail_rid != '') {
                this.$router.push({
                    path: '/dealDetailDetail',
                    query: {
                        id: row.deal_detail_rid
                    }
                });
            }
        },
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('partner_current_deduction_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('partner_current_deduction', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).partner_current_deduction;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'partnerCurrentDeductionLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        //新增
        insert() {},
        reset() {
            this.initQueryParams();
            this.$refs.approval_status_ref && this.$refs.approval_status_ref.reset();
            this.getList();
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>